export enum TimeResolution {
    ONE_HOUR = 'hora',
    ONE_DAY = 'dia',
    ONE_MONTH = 'mes',
}